import * as React from "react";
import DesignIdeaMain from "./";

const DesignIdea: React.FC = () => {
  return <DesignIdeaMain isManagementEnd />;
};

export default React.memo(DesignIdea);
